import { SvgIcon } from "@mui/material";
import { t } from "i18next";
import { useState } from "react";
import { RedCancellationCrossIcon } from "../../../assets/customIcons";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { WorkPurchaseInvoiceKeys, WorkPurchaseInvoiceStatusEnum } from "../services/entity";
var CancelDocument = function (props) {
    var openPopper = props.openPopper, cancellationReasonAPI = props.cancellationReasonAPI, cancelAPI = props.cancelAPI, id = props.id, handleClose = props.handleClose;
    var _a = useState(true), reason = _a[0], setReason = _a[1];
    var _b = useState(), cancellationReason = _b[0], setCancellationReason = _b[1];
    var handleConfirmClick = function () {
        handleClose === null || handleClose === void 0 || handleClose();
        setReason(true);
        return 'submit';
    };
    var formdata = [{
            type: FormItemTypes.Custom,
            name: "",
            label: "",
            value: null,
            element: function () { /*#__PURE__*/ return React.createElement(SvgIcon, {
                component: RedCancellationCrossIcon,
                sx: {
                    height: "48px",
                    width: "48px"
                }
            }); },
            columnSize: 12
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            label: '',
            value: null,
            columnSize: 12,
            spacing: 0,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'Header',
                    label: "",
                    value: null,
                    children: "Are you sure you want to cancel?",
                    variant: 'h1',
                    fontSize: "18px",
                    flexDirection: "column",
                    columnGap: 0,
                    columnSize: 12
                }, {
                    type: FormItemTypes.Typography,
                    name: 'Header',
                    label: "",
                    value: null,
                    children: t("Select a cancellation reason below to confirm."),
                    fontSize: "14px",
                    color: "#8593A3",
                    flexDirection: "column",
                    columnGap: 0,
                    columnSize: 12
                }]
        }, {
            type: FormItemTypes.SearchSelect,
            name: 'RejectRemarkId',
            label: 'Cancellation reason',
            placeholder: 'Select a cancellation reason',
            value: null,
            displayExpr: "Name",
            valueExpr: "id",
            setFormState: function () { return ({
                RejectRemarkId: null
            }); },
            onChange: function (e, value) {
                setCancellationReason(value);
                if (!value) {
                    setReason(!value);
                    return;
                }
                ;
                setReason((value === null || value === void 0 ? void 0 : value.Name) === "Others");
            },
            getListData: cancellationReasonAPI,
            columnSize: 12
        }, {
            type: FormItemTypes.TextInput,
            name: 'RejectRemark',
            label: 'Remark (0/200 characters)',
            placeholder: 'Write cancellation reason here...',
            maxLength: 200,
            value: null,
            minRows: 3,
            multiline: true,
            setFieldProps: function (formValues, value) {
                var _value$length;
                return {
                    type: this.type,
                    label: "Remark (".concat((_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0, "/200 characters)")
                };
            },
            onChange: function (e, value) {
                if (cancellationReason) {
                    if (value || (cancellationReason === null || cancellationReason === void 0 ? void 0 : cancellationReason.Name) === 'Others') {
                        setReason(!(value !== null && value !== void 0 && value.trim()));
                    }
                    else {
                        setReason(value === null || value === void 0 ? void 0 : value.trim());
                    }
                }
            },
            columnSize: 12
        }, {
            type: FormItemTypes.Button,
            name: 'cancel',
            label: '',
            value: null,
            children: 'Cancel',
            columnSize: 6,
            onClick: function () {
                handleClose();
                setReason(true);
            },
            fullWidth: true,
            variant: 'outlined',
            sx: {
                borderColor: '#DEE4EB',
                color: "#6A7682"
            }
        }, {
            type: FormItemTypes.Button,
            name: 'confirm',
            label: '',
            value: null,
            children: 'Confirm',
            columnSize: 6,
            disabled: reason,
            fullWidth: true,
            variant: 'contained',
            sx: {
                bgcolor: '#F5222D',
                color: "#FFF"
            },
            onClick: handleConfirmClick
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formdata,
        pagingAPIKey: WorkPurchaseInvoiceKeys.Paging,
        createFormAPI: cancelAPI,
        createKey: WorkPurchaseInvoiceKeys.Cancel,
        createRequest: {
            PurchaseOrderId: id,
            Status: WorkPurchaseInvoiceStatusEnum.Cancelled
        },
        onClose: handleClose
    });
};
export default CancelDocument;
